<template>
    <a>
        <span class="icon">
            <img :src="iconClass">
        </span>
        <span class="tit">{{data.project}}</span>
        <span class="wmName">{{data.studio}}</span>
    </a>
</template>
<script>
    export default {
        name: 'ProjectItem',
        props:['data'],
        data(){
            return {
            }
        },
        computed:{
            iconClass(){
                return require('@/pages/frontend/assets/images/' + this.data.icon)
            }
        },
    }
</script>